var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider-container"},[_c('vue-slider',{ref:"slider",attrs:{"piecewise":true,"height":8,"reverse":false,"data":_vm.rangeData,"tooltip":false,"dot-size":20},on:{"callback":_vm.changed,"drag-end":_vm.ended},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }